export default __webpack_public_path__ + "static/media/638.ff568dd6.png";